orders-result-checking-orders-csv
  .result.mb-5(if="{opts.result}")
    .row
      .col-lg-1.mb-1
        strong { opts.labels.jobno }
      .col-lg-2.mb-1
        strong { opts.labels.status }
      .col-head.col-lg-3.mb-1
        strong { opts.labels.deadline }
        br
        span.d-inline-block.mr-1
          .icon-wrap.bg-danger
            i.fas.fa-exclamation
          | 月が違う
        span.d-inline-block.mr-1
          .icon-wrap.bg-warning
            i.fas.fa-exclamation
          | 14日以上違う
        span.d-inline-block.mr-1
          .icon-wrap.border-info.text-info
            i.fas.fa-info
          | 7日以上違う
        span.d-inline-block.mr-1
          .icon-wrap.border-success.text-success
            i.fas.fa-info
          | 1日以上違う
      .col-head.col-lg-3.mb-1
        strong { opts.labels.client_name }
        br
        span.d-inline-block.mr-1
          .icon-wrap.bg-danger
            i.fas.fa-exclamation
          | 差異指数0.75以上
        span.d-inline-block.mr-1
          .icon-wrap.bg-warning
            i.fas.fa-exclamation
          | 差異指数0.45以上
        span.d-inline-block.mr-1
          .icon-wrap.border-info.text-info
            i.fas.fa-info
          | 差異指数0.2以上
      .col-head.col-lg-3.mb-1
        strong { opts.labels.product_name }
        br
        span.d-inline-block.mr-1
          .icon-wrap.bg-danger
            i.fas.fa-exclamation
          | 差異指数0.75以上
        span.d-inline-block.mr-1
          .icon-wrap.bg-warning
            i.fas.fa-exclamation
          | 差異指数0.45以上
        span.d-inline-block.mr-1
          .icon-wrap.border-info.text-info
            i.fas.fa-info
          | 差異指数0.2以上
    hr
    .row(each="{opts.orders}")
      .col-lg-1.mb-1
        .pt-1.pb-1
          a(href="{edit_path}" target="_blank") { jobno }
      .col-value.col-lg-2.mb-1
        .pt-1.pb-1
          span.icon-wrap(class="{diff_status_class(diff_status)}")
            i(class="{diff_status_icon(diff_status)}")
          span.label.label-success.label-ot OT
          span.mr-1 { status }
          br
          span.label.label-primary.label-zac ZAC
          span { zac_status }
      .col-value.col-lg-3.mb-1
        .pt-1.pb-1
          span.icon-wrap(class="{diff_deadline_class(diff_deadline, diff_deadline_month_flg)}")
            i(class="{diff_deadline_icon(diff_deadline, diff_deadline_month_flg)}")
          span.label.label-success.label-ot OT
          span.mr-1 { deadline }
          br
          span.label.label-primary.label-zac ZAC
          span { zac_deadline }
      .col-value.col-lg-3.mb-1
        .pt-1.pb-1
          span.icon-wrap(class="{diff_client_name_class(diff_client_name)}")
            i(class="{diff_client_name_icon(diff_client_name)}")
          span.label.label-success.label-ot OT
          span.mr-1 { client_name }
          br
          span.label.label-primary.label-zac ZAC
          span { zac_client_name }
      .col-value.col-lg-3.mb-1
        .pt-1.pb-1
          span.icon-wrap(class="{diff_product_name_class(diff_product_name)}")
            i(class="{diff_product_name_icon(diff_product_name)}")
          span.label.label-success.label-ot OT
          span.mr-1 { product_name }
          br
          span.label.label-primary.label-zac ZAC
          span { zac_name }
    .row.mt-5(each="{opts.years_months}")
      .col-12
        h6 { year_month }
        orders-table(tag-scope="orders_result_checking_orders_csv.{scope}")
  script(type="typescript").
    this.mixin('orders.result-checking-orders-csv');
  style(scoped).
    .notfound_title {
      margin-top: 40px;
    }
    .label {
      margin-right: 2px;
      display: inline-block;
    }
    .col-value,
    .col-head {
      position: relative;
    }
    .col-head .icon-wrap,
    .col-value .icon-wrap {
      border-radius: 50%;
      text-align: center;
      display: inline-block;
      text-transform: capitalize;
      font-size: 15px;
      width: 20px;
      height: 20px;
      padding: 1px;
      line-height: 18px;
      border: 1px solid #FFF;
    }
    .col-value .icon-wrap {
      position: absolute;
      left: -6px;
      top: 6px;
    }
    .label-zac,
    .label-ot {
      width: 40px;
      text-align: center;
    }
